export default "__VITE_ASSET__CdvyUd7q__"